import { LayoutWithNavigationBar } from "../../../layouts/layout-with-navigation-bar";
import { MainView } from "../../../views/inbound/stage";

export default function Inbound_StagePage(props) {
    return (
        <>
            <LayoutWithNavigationBar>
                <MainView />
            </LayoutWithNavigationBar>
        </>
    );
}